/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FetchAssetFromUrlBody
 */
export interface FetchAssetFromUrlBody {
    /**
     * External URL of the image to fetch
     * @type {string}
     * @memberof FetchAssetFromUrlBody
     */
    url: string;
}

/**
 * Check if a given object implements the FetchAssetFromUrlBody interface.
 */
export function instanceOfFetchAssetFromUrlBody(value: object): value is FetchAssetFromUrlBody {
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function FetchAssetFromUrlBodyFromJSON(json: any): FetchAssetFromUrlBody {
    return FetchAssetFromUrlBodyFromJSONTyped(json, false);
}

export function FetchAssetFromUrlBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): FetchAssetFromUrlBody {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function FetchAssetFromUrlBodyToJSON(json: any): FetchAssetFromUrlBody {
    return FetchAssetFromUrlBodyToJSONTyped(json, false);
}

export function FetchAssetFromUrlBodyToJSONTyped(value?: FetchAssetFromUrlBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
    };
}

